import { graphql, useStaticQuery } from "gatsby";
import { useMemo } from "react";
import { normalizeRelativePath } from "../utility/paths";

const useStoreLocator = () => {
  const {
    storePage,
    config: { storeLocatorPage },
  } = useStaticQuery(graphql`
    {
      storePage {
        slug
      }
      config: liferayGeneralConfiguration {
        storeLocatorPage {
          ... on LiferayPage {
            slug
          }
        }
      }
    }
  `);

  const storeLoc = storeLocatorPage ? storeLocatorPage.slug : storePage?.slug;

  const storePageLink = useMemo(() => normalizeRelativePath(storeLoc), [storeLoc]);

  return storePageLink && storeLoc ? storePageLink : null;
};

export default useStoreLocator;
